var React = require('react');

function ChevronRightCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.2,15.2c-0.5-0.8-1.6-1-2.4-0.5c-0.8,0.5-1,1.6-0.5,2.4L35.4,32L25.3,46.8c-0.5,0.8-0.3,1.9,0.5,2.4 c0.3,0.2,0.6,0.3,1,0.3c0.6,0,1.1-0.3,1.4-0.8l10.4-15.4c0.6-0.8,0.6-2.1,0-2.9L28.2,15.2z","key":0}),React.createElement("path",{"d":"M32,1.3C15,1.3,1.3,15,1.3,32C1.3,49,15,62.8,32,62.8C49,62.8,62.8,49,62.8,32C62.8,15,49,1.3,32,1.3z M32,59.3 C17,59.3,4.8,47,4.8,32C4.8,17,17,4.8,32,4.8C47,4.8,59.3,17,59.3,32C59.3,47,47,59.3,32,59.3z","key":1})]);
}

ChevronRightCircle.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = ChevronRightCircle;

ChevronRightCircle.default = ChevronRightCircle;
